import { render, staticRenderFns } from "./container-faq.vue?vue&type=template&id=0b5e3b46&scoped=true&"
import script from "./container-faq.vue?vue&type=script&lang=js&"
export * from "./container-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5e3b46",
  null
  
)

export default component.exports